import React from "react";
import { Link } from "react-router-dom";
import { getSunday, getWeeksPassed } from "../utils/plan-utils";
import { useTranslation } from "react-i18next";
import { Plan } from "src/graphql";
import avatar_placeholder from 'src/assets/images/avatar-placeholder.png'


interface PlanSectionProps {
    activePlan: Partial<Plan>
}
const PlanSection: React.FC<PlanSectionProps> = ({ activePlan }) => {

    const { t } = useTranslation();

    return (
        <div className='flex flex-row flex-wrap gap-8 md:w-full mb-4'>
            <div className='flex-row flex gap-2 items-center w-full md:w-auto'>
                <div>
                    <img src={activePlan.trainer?.picture || avatar_placeholder} alt='avatar' className='avatar object-cover ' />
                </div>
                <div>
                    <p className='light'>{t("trainer")}</p>
                    <p className=''>{activePlan.trainer?.name}</p>
                </div>
            </div>
            <div className='w-full md:w-auto'>
                <p className='light'>{t("training_sessions")}</p>
                <p>8 {t("sessions")}</p>
            </div>
            <div>
                <p className='light'>{t("total_duration")}</p>
                <p>{activePlan.weeks} {t("weeks")}</p>
            </div>
        </div>
    );
}

export default PlanSection;